import { SourceTypeWithString } from "src/api/product";
var _SourceTypeWithString_value;
/**
 * 상품종류 표기. SourceTypeWithString 의 키를 라벨로 옮긴다 (handout = '자료').
 * 매핑에 없는 값이면 원문을 그대로 노출한다 — 행을 숨기면 BE 가 새 타입을 내려도 알아채지 못한다.
 */ const toProductTypeLabel = (value)=>(_SourceTypeWithString_value = SourceTypeWithString[value]) !== null && _SourceTypeWithString_value !== void 0 ? _SourceTypeWithString_value : value;
/**
 * 사용범위 한 항목의 표시값.
 * BE 필드 구성 확정 전이라 배열로 올 수 있어 ', ' 로 이어 붙인다 (시안: '영어, 국어').
 * 빈 문자열·빈 배열은 null 로 떨어져 행이 생성되지 않는다.
 */ const toDisplayValue = (value, transform)=>{
    const items = (Array.isArray(value) ? value : [
        value
    ]).filter((item)=>typeof item === "string" && item.trim() !== "").map((item)=>transform ? transform(item) : item);
    return items.length ? items.join(", ") : null;
};
/**
 * '이용권 사용범위' 표. 시안(3203:138568 / 3203:138494)의 5행 구성이 기준이다.
 *
 * 값이 없는 항목은 행을 만들지 않고, 전부 없으면 섹션 자체가 사라진다.
 * 결제 페이지(`SubscriptionPlanBenefitItem`)와 구독 관리(`SubscriptionCoverage`)가
 * 같은 표를 그리므로 라벨·상품종류 매핑을 여기 한 곳에만 둔다.
 * 입력 키는 구독 상세 응답 기준의 **복수형**이다 — 단수형 키를 쓰는 결제 쪽이 감싸서 넘긴다.
 */ export const buildCoverageSection = (coverage)=>{
    if (!coverage) return null;
    const rows = [];
    const pushRow = (label, value)=>{
        if (value) rows.push({
            label,
            value
        });
    };
    pushRow("과목", toDisplayValue(coverage.subjects));
    pushRow("과정", toDisplayValue(coverage.courses));
    // 제외 저자가 아니라 사용 가능 저자다 (시안 표기)
    pushRow("가능 저자", toDisplayValue(coverage.authors));
    pushRow("출판사", toDisplayValue(coverage.publishers));
    pushRow("상품종류", toDisplayValue(coverage.productTypes, toProductTypeLabel));
    if (!rows.length) return null;
    return {
        id: "scope",
        layout: "table",
        title: "이용권 사용범위",
        labelWidth: "sm",
        rows
    };
};
/**
 * '이용권 상세정보' 불릿. 본문이 없으면 제목만 남으므로 섹션을 생략한다.
 * (보유 이용권 다이얼로그는 빈 섹션을 유지하는데, 구독은 시안에 그 상태가 없다)
 */ export const buildSubscriptionDescriptionSection = (description)=>{
    if (!description) return null;
    return {
        id: "description",
        layout: "bullets",
        title: "이용권 상세정보",
        items: description.split("\n")
    };
};
